export const getGuidelineColumns = (translate) => {
  return [
    {
      dataField: 'deliveryType',
      type: 'string',
      text: translate('Type'),
      sort: false,
      sortValue: (cell, row) => row.deliveryType,
      headerStyle: { backgroundColor: '#F8F9FA', width: '11.75rem' },
    },
    {
      dataField: 'title',
      type: 'string',
      sortValue: (cell, row) => row.title,
      text: translate('Guideline'),
      sort: false,
      headerStyle: {
        backgroundColor: '#F8F9FA',
      },
    },
    {
      dataField: 'publishedDate',
      type: 'date',
      sortValue: (cell, row) => row.publishedDate,
      text: translate('Publication date'),
      sort: false,
      headerStyle: {
        backgroundColor: '#F8F9FA',
        width: '11.75rem',
      },
    },
    {
      dataField: 'publishedUrl',
      type: 'string',
      sortValue: (cell, row) => row.publishedUrl,
      text: 'URL',
      sort: false,
      headerStyle: {
        backgroundColor: '#F8F9FA',
        width: '19.625rem',
      },
    },
    {
      dataField: 'action',
      searchable: false,
      text: ' ',
      headerStyle: {
        backgroundColor: '#F8F9FA',
        width: '30px',
        textAlign: 'center',
      },
    },
  ];
};
